// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tatsugiri_stretchy: PokeData = {
  "id": 10259,
  "name": "tatsugiri-stretchy",
  "height": 3,
  "weight": 80,
  "base_experience": 166,
  "types": [
    PokeType.DRAGON,
    PokeType.WATER
  ],
  "api_moves": [
    "water-gun",
    "harden",
    "splash",
    "mirror-coat",
    "memento",
    "taunt",
    "helping-hand",
    "muddy-water",
    "water-pulse",
    "dragon-pulse",
    "nasty-plot",
    "soak"
  ],
  "moves": [
    "splash",
    "dragon-pulse",
    "dragon-breath",
    "liquidation",
    "dragon-fang",
    "inner-spirit",
    "rain-dance",
    "aqua-tail",
    "bubble-beam",
    "dragon-claw",
    "aqua-cutter",
    "dragon-dance",
    "brine"
  ],
  "evolution_chain": {
    "id": 514,
    "item": null,
    "species": [
      {
        "name": "tatsugiri",
        "order": 952,
        "types": [
          PokeType.DRAGON,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 106,
    "speed": 119,
    "ability_power": 175
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
